import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { deepOrange, blue } from '@material-ui/core/colors';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles(theme => {
  return {
    ccAvatar: {
      background: deepOrange[900],
      color: ['#fff', '!important']
    },
    ccChip: {
      background: deepOrange[500],
      color: '#fff',
    },
    dxAvatar: {
      background: blue[900],
      color: ['#fff', '!important']
    },
    dxChip: {
      background: blue[500],
      color: '#fff'
    }
  };
});

const noOp = () => {};

// https://www.merriam-webster.com/dictionary/delible
const CodeChip = ({
  encoding,
  onDelete,
  onClick,
  title,
  isDelible = false,
}) => {
  const classes = useStyles();

  // if it has a 'type' field it is a CC, otherwise a DX
  // this will obviously change in the future to be more robust
  const hasType = encoding.type !== undefined && encoding.type !== null;

  const conditionalDelete = isDelible ? { onDelete } : {};
  const conditionalOnClick = onClick || noOp;

  return (
    <Chip
      {...conditionalDelete}
      className={hasType ? classes.ccChip : classes.dxChip}
      size="small"
      avatar={(
        <Avatar className={hasType ? classes.ccAvatar : classes.dxAvatar}>
          {
            hasType
              ? (
                encoding.type === undefined || encoding.type === null
                  ? 'CC' // TODO see what avatar should be
                  : encoding.type.toUpperCase()
                )
              : 'DX'
          }
        </Avatar>
      )}
      label={encoding.code}
      onClick={conditionalOnClick}
      title={title}
    />
  );
};

CodeChip.propTypes = {
  isDelible: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  encoding: PropTypes.shape({
    code: PropTypes.string
  }).isRequired
};

export default CodeChip;
